import { labelids } from "../../assets/data/TkExplanationProperty";
import { ITkFakeTableLineProps } from "../../type/componentsType/TkFakeTableLine";
import TkPropertyMessageGet from "../../utils/TkPropertyMessageGet";

const stepperRetirement = [
  "退職者の基本情報登録",
  "添付書類の登録",
  "従業状況の登録確認",
  "退職した月以前6ヶ月の本俸額登録",
  "退職手当金請求の順番登録",
  "添付書類の確認",
  "登録内容の確認",
  "機構へ提出",
];

const stepperTransfer = [
  "退職者の基本情報登録",
  "従業状況の登録確認",
  "退職した月の本俸月額登録",
  "登録内容の確認",
  "機構へ提出",
];

const infoHeadTitleList: any[] = [
  {
    headTitle: "順番",
  },
  {
    headTitle: "出生日",
  },
  {
    headTitle: "育児休業開始日",
  },
  {
    headTitle: "育児休業終了日",
  },
  {
    headTitle: "パパ・ママ育休プラス",
  },
  {
    headTitle: "半年延長の理由",
  },
  {
    headTitle: "産後パパ育休",
  },
];

const fakeTableList: ITkFakeTableLineProps[] = [
  {
    keyword: "info",
    type: "explanatoryText",
    explanatoryText: labelids.labelid.LBLC060122_01,
  },
  {
    keyword: "contractorName",
    type: "contractorAndNumber",
    contractorName: "契約者（法人）名",
    showLine: false,
  },
  {
    title: "職員番号",
    keyword: "staffNo",
    type: "text",
    disabled: true,
  },
  {
    title: "退職者名",
    keyword: "retireeName",
    type: "text",
    disabled: true,
  },
  {
    keyword: "lineTitle",
    type: "lineTitle",
    lineTitle: "",
  },
  {
    title: "退職年度のならない月",
    keyword: "exclusionMonth",
    requiredIcon: true,
    type: "checkboxGroup",
    helpicon: true,
    helpText: (
      <>
        表示されている年度のならない月を登録してください。
        <br />
        ならない月とは、業務に従事した日数（従事したとみなす日を含む）が１０日を超えない月です。
        <br />
        詳しくは
        <a
          href={`${
            process.env.PUBLIC_URL ?? ""
          }/assets/pdf/≪別紙≫「なる月」「ならない月」について.pdf`}
          target="_blank"
          rel="noreferrer"
        >
          こちら
        </a>
        をご確認ください。
        <br />
      </>
    ),
    checkBoxList: [
      { label: "無", key: "none", defaultChecked: true, disabled: true },
      { label: "4月", key: "apr" },
      { label: "5月", key: "may" },
      { label: "6月", key: "jun" },
      { label: "7月", key: "jul" },
      { label: "8月", key: "aug" },
      { label: "9月", key: "sep" },
      { label: "10月", key: "oct" },
      { label: "11月", key: "nov" },
      { label: "12月", key: "dec" },
      { label: "1月", key: "jan" },
      { label: "2月", key: "feb" },
      { label: "3月", key: "mar" },
    ],
  },
  {
    title: "退職月の出勤日数",
    keyword: "workingDayNum",
    type: "inputWithText",
    innerText: "日",
    onlyNumber: true,
    inputProps: { maxLength: 2 },
    requiredIcon: true,
    showLine: false,
    useNumberValue: true,
  },
];

const schema = (dayNum: number) => {
  return {
    workingDayNum: {
      required: TkPropertyMessageGet("TKMSG_SCR0043E"),
      max: {
        value: dayNum,
        message: TkPropertyMessageGet("TKMSG_SCR0048E", `${dayNum}`),
      },
    },
  };
};

const months = {
  4: "apr",
  5: "may",
  6: "jun",
  7: "jul",
  8: "aug",
  9: "sep",
  10: "oct",
  11: "nov",
  12: "dec",
  1: "jan",
  2: "feb",
  3: "mar",
} as { [key: string]: any };

const headListWorkingDayNum: any[] = [
  {
    headTitle: "対象年月",
  },
  {
    headTitle: "出勤日数",
  },
];

export {
  stepperRetirement,
  stepperTransfer,
  infoHeadTitleList,
  fakeTableList,
  schema,
  months,
  headListWorkingDayNum,
};
